import { http } from './config'

export default {

  getAllClients: () => {
    return http.get('clients')
  },

  getFilteredClients: (params) => {
    return http.get('clients', {params})
  },

  getClientById: (clientId) => {
    return http.get('clients/' + clientId)
  },

  getClientByName: (clientName) => {
    return http.get('clients/by_client_name/' + clientName)
  },

  createClient: (clientParams) => {
    return http.post('clients', {
      name: clientParams.name,
      trading_name: clientParams.trading_name,
      address: clientParams.address,
      district: clientParams.district,
      city: clientParams.city,
      state: clientParams.state,
      zip_code: clientParams.zip_code,
      latitude: clientParams.latitude,
      longitude: clientParams.longitude,
      start_of_service: clientParams.start_of_service,
      end_of_service: clientParams.end_of_service,
      cpf_cnpj: clientParams.cpf_cnpj
    }
  )},

  updateClient: (clientParams) => {
    return http.put('clients/' + clientParams.id, {
      name: clientParams.name,
      trading_name: clientParams.trading_name,
      address: clientParams.address,
      district: clientParams.district,
      city: clientParams.city,
      state: clientParams.state,
      zip_code: clientParams.zip_code,
      latitude: clientParams.latitude,
      longitude: clientParams.longitude,
      start_of_service: clientParams.start_of_service,
      end_of_service: clientParams.end_of_service,
      cpf_cnpj: clientParams.cpf_cnpj
    }
  )},

  deleteClient: (clientId) => {
    return http.delete('clients/' + clientId)
  },
}
